import React, {Component} from 'react';
import RealTimeContext from "./RealTimeContext";
import ApiAutoCaller from "../utils/ApiAutoCaller";
import axios from "axios";
import {host} from "../utils/constants";

class RealTimeProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.autoCallers = {};
        this.token = this.props.token;
    }

    start(serial) {
        if (serial in this.autoCallers) {
            return
        }

        const apiAutoCaller = new ApiAutoCaller(
            this.fetchRealTime.bind(this, serial),
            this.handleRealTime.bind(this, serial),
            30000,
            10000
        );
        apiAutoCaller.start();
        this.autoCallers[serial] = apiAutoCaller;
    }

    fetchRealTime(serial) {
        return axios.get(`${host}/public/devices/${serial}/realtime`, {
            headers: {
                'Authorization': `Bearer ${this.token}`
            },
        });
    }

    handleRealTime(serial, data) {
        if (data['statusCode']) {
            if (data['statusCode'] === 504) {
                this.setState({
                    [serial]: {status: 'offline'}
                });
            }
            return;
        }

        this.setState({
            [serial]: {
                ...data,
                status: 'online'
            }
        })
    }

    render() {
        return (
            <RealTimeContext.Provider value={{
                start: this.start.bind(this),
                state: this.state
            }}>
                {this.props.children}
            </RealTimeContext.Provider>
        );
    }
}

RealTimeProvider.propTypes = {};

export default RealTimeProvider;
